<template>
  <v-app id="inspire" dark>
    <v-navigation-drawer v-if="isLoggedIn" v-model="drawer" clipped fixed app>
      <v-list dense>
        <v-list-tile v-for="item in navItems" :key="item.id" router :to="item.path">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon v-if="isLoggedIn" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>KRDM</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase';
// import Header from './components/Header.vue';

export default {
  name: 'App',
  components: {
    // Header
  },
  data() {
    return {
      navItems: [
        {
          id: '001',
          icon: 'home',
          title: 'Domov',
          path: '/',
        },
        {
          id: '004',
          icon: 'persons',
          title: 'Člani',
          path: '/users',
        },
        {
          id: '002',
          icon: 'person',
          title: 'Moj profil',
          path: '',
        },
        {
          id: '003',
          icon: 'info',
          title: 'O aplikaciji',
          path: '/about',
        },
      ],
      drawer: null,
      apiUrl: process.env.VUE_APP_API,
      isLoggedIn: false,
      currentUser: false,
    };
  },

  created() {
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser;
      const profileLink = this.navItems.find(el => el.id === '002');
      profileLink.path = `/users/${this.currentUser.uid}`;
      console.log(this.currentUser.uid);
    }
  },
};
</script>
